module.exports = __webpack_public_path__ + "media/intro.a782f075.mp4";